import angular from 'angular';

export const viewsModule = angular.module(
  'portainer.azure.react.views',
  []
).name;
